import * as z from 'zod'

import { api } from '../../utils/api'
import { UserModuleSchema } from '../../models/modules/userModule'

const InputSchema = z.tuple([z.object({
	username: z.string().nonempty()
})])

const OutputSchema = z.promise(UserModuleSchema.array())

const FunctionSchema = z.function(InputSchema, OutputSchema)

export const GetModules = FunctionSchema.implement(async ({ username }) => await api.get(`/user/${username}/modules`))